//  eslint-disable react-hooks/exhaustive-deps
import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import ButtonCreate from "../../components/drawer/ButtonCreate";
import AppDrawer from "../../components/drawer/Drawer";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import {
  deleteTypeOfService,
  getAllTypeofService,
  TypeOfServiceActiveInactive,
} from "./services/typeofservice.services";
import { clearTypeofServiceID, setTypeofServiceID } from "./typeofserviceSlice";
import CreateTypeofService from "./CreateTypeofService";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";

const TypeofService: React.FC = () => {
  const dispatch = useAppDispatch();
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllTypeofService());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteTypeofServiceDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Type Of Service List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Create Type of Service"
              drawerName="typeofserviceForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <TypeofServiceGridComponent />
        </GridLayoutItem>
        {isDrawerOpen && drawerName === "typeofserviceForm" && (
          <AppDrawer>
            <CreateTypeofService />
          </AppDrawer>
        )}
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const TypeofServiceGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const TypeofServiceList = useAppSelector(
    (state) => state.typeofservice.TypeofServiceList
  );
  const loading = useAppSelector((state) => state.typeofservice.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? TypeofServiceList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deletetTypeofService"));
      dispatch(setTypeofServiceID(ID));
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.types_of_services_guid}
            drawerName="typeofserviceForm"
            tooltipTitle="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem.types_of_services_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.isactive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        types_of_services_guid: props.dataItem.types_of_services_guid,
        isactive: !IsActive,
      };
      dispatch(TypeOfServiceActiveInactive(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllTypeofService());
        } else {
          dispatch(getAllTypeofService());
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          name="IsActive"
          checked={IsActive}
          disabled={isEditAccess ? false : true}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {TypeofServiceList && TypeofServiceList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          className="responsive-table"
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(TypeofServiceList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : TypeofServiceList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={TypeofServiceList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="types_of_services"
            title="Type Of Services"
            cell={(props: any) => (
              <td className={isEditAccess ? "hoverableName" : "normalName"}>
                {isEditAccess ? (
                  <ButtonEdit
                    ID={props.dataItem.types_of_services_guid}
                    drawerName="typeofserviceForm"
                    label={props.dataItem?.types_of_services}
                  />
                ) : (
                  props.dataItem?.types_of_services
                )}
              </td>
            )}
          />

          <Column
            field="types_of_services_guid"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          <Column
            field="types_of_services_guid"
            title="Actions"
            cell={MyEditCommandCell}
            width={"110px"}
            filterable={false}
          />
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteTypeofServiceDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const TypeofServiceID = useAppSelector(
    (state) => state.typeofservice.TypeofServiceID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteTypeOfService(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllTypeofService());
        dispatch(closeDialog());
        dispatch(clearTypeofServiceID());
      } else {
        dispatch(getAllTypeofService());
        dispatch(closeDialog());
        dispatch(clearTypeofServiceID());
      }
    }
  };

  return (
    <>
      {dialogName === "deletetTypeofService" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Type of Service?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Type of Service?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TypeofServiceID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default TypeofService;
